import React, { useEffect, useState } from 'react';
import axios from '../../interceptors/interceptors';
import { DirectLine, } from 'botframework-directlinejs';
import * as Cards from './cards';
import ToastDialog from './dialogs/ToastDialog';
import DebugDialog from './dialogs/DebugDialog';
import { logEventHub } from './utils';
import { ConnectionStatus } from 'botframework-directlinejs';
import { connectErrCard, timeoutCard,sessionTimeoutCard } from './messages'
import { thankyou, age, error, timeOut, testMsg, prompt, infotest, disclaimer,disclaimernew, symptomCard, symptomsDurationCard,symptomsQuestionCard, confirm, confirmVirtual, summaryMessage, calendar, apterror, provider, welcome, welcomenew,treatmentplan, multiChoice, groupMulti, nps, singleNext } from './test-messages';
import '../../stylesheets/triagebot/TriageBotEngine.scss';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { useGlobalContext } from '../../context/global-context-provider'
import { TimingProvider, useTiming } from './TimingContext';

let directLine;
let directlineListener;
let directlineStatus;
let conversationHBID = null; // Captured from incoming bot activity ids; reliable HBID source
let lastSentAt = null;	
const directLineTokenUrl = '/api/directline-token';
const reconnectUrl = '/api/directline-reconnect';
const trigger = process.env.REACT_APP_TRIGGER;
const filter = process.env.REACT_APP_FILTER_ID;
const allowRestart = process.env.REACT_APP_ALLOW_RESTART;
//const appId = process.env.REACT_APP_APP_ID;
const env = process.env.REACT_APP_ASYNC_ENVIRONMENT;
const params = new URLSearchParams(window.location.search);

const cardMap = {
  proselect: singleNext,
  groupmulti: groupMulti,
  confirm: confirm,
  confirmvirtual: confirmVirtual,
  summary: summaryMessage,
  appointment: calendar,
  apterror: apterror,
  provider: provider,
  welcome: welcome,
  welcomenew: welcomenew,
  plan: treatmentplan,
  multiselect: multiChoice,
  singleselect: prompt,
  symptoms: symptomCard,
  symptomsduration: symptomsDurationCard,
  symptomsquestion:symptomsQuestionCard,
  disclaimer: disclaimer,
  disclaimernew:disclaimernew,
  infotest: infotest,
  test: testMsg,
  timeout: timeOut,
  error: error,
  nps: nps,
  age: age,
  thankyou: thankyou
};

export function TriageBotContainer({ setSummaryPrintData, updateProgress, showDebug, setShowDebug, setRestart, profile, showWelcomeIllustration, HoverColor }) {	
  const [isStarting, setIsStarting] = useState(true); // Loading Directline
  const [isTriageOver, setIsTriageOver] = useState(false);
  const [isConversationOver, setIsConversationOver] = useState(false);
  const [supressScreen, setSupressScreen] = useState(false);
  const [isNPSAnswered, setIsNPSAnwered] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [suppressSummary, setSuppressSummary] = useState(false);
  const [isLaunchCodeExists, setIsLaunchCodeExists] = useState(false);
  const [symptomError, setSymptomError] = useState(null);
  const [messages, setMessages] = useState(
    params.has('startcard')
      ? [JSON.stringify(cardMap[params.get('startcard')])]
      : []
    );
  const isIPhoneSafari = (() => {
      const ua = navigator.userAgent || '';
      // Detect Apple devices
      const isAppleDevice = /iPhone|iPad|iPod|Macintosh|Mac OS X/i.test(ua);
      // Detect Safari (more accurate detection)
      const safari = /Safari/i.test(ua) && 
                    !/Chrome|Chromium|Edg|CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/i.test(ua);
          return isAppleDevice && safari;
      })();



  const getDeviceInfo = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const maxTouchPoints = navigator.maxTouchPoints || 0;

      if (/Android.*Mobile/.test(userAgent)) return 'MobileAndroid';
      if (/iPhone/.test(userAgent)) return 'MobileIOS';
      if (/Android(?!.*Mobile)/.test(userAgent)) return 'TabletAndroid';
      if (/iPad/.test(userAgent) || (userAgent.includes('Macintosh') && maxTouchPoints >= 1)) return 'TabletIOS';
      return 'Desktop';
    };

    const deviceTypeVal = getDeviceInfo()
   

    const { GatewayToken, InfermedicaToken, UseSpanishVariation: _UseSpanishVariation, Locale: _Locale, CdoName: cdoName, AppID: appId } = useGlobalContext();
  console.log('Triage Bot Engine Started..')
    console.log('GatewayToken For Directline: ', GatewayToken);
    console.log("Cdoname and AppId in TriageEngine: " + cdoName + " " + appId);
  // This is for debugging purposes only
  if (params.get('startcard') === 'summary')
    setTimeout(() => {
      setSummaryPrintData(cardMap['summary']);
    });
  let isAfterSummaryorTreatmentPlan = false;
  // use the commented code below to use mock LaunchCode, if new cdo arrives
    const launchCode = process.env.REACT_APP_MOCKLAUNCHCODE?.split('|')?.[1] === '1' ? (process.env.REACT_APP_MOCKLAUNCHCODE?.split('|')[0]).trim() : (params.get('launch') || '').trim();
   
  const profileId = profile?.id
    ? profile.id
    : "0"

   // Mock Spanish users for incubator CDO
  const MOCK_SPANISH_USER_IDS = ['TujkdYb4onVuTAEHRF39', 'SrY766yxc8XDYsKirM15'];
  const isMockSpanishUser = cdoName?.toLowerCase() === 'optumincubator' && MOCK_SPANISH_USER_IDS.includes(profileId);
  const Locale = isMockSpanishUser ? 'es-US' : (_Locale || 'en-US');
  const UseSpanishVariation = isMockSpanishUser ? true : _UseSpanishVariation;

  const addHBIDtoDocument = () => {
    if (env.toLocaleLowerCase() !== 'production') {
      const el = document.getElementById('triage-bot');
      if (el)
        el.setAttribute('data-hbid', directLine.conversationId)
    }
  }
  const addHBIDtoDataDog = () => {
    datadogRum.setGlobalContext({
      AsyncHBID: directLine.conversationId,            
    });
    datadogLogs.setGlobalContext({
      AsyncHBID: directLine.conversationId,
    });
  }

  const logClientIpTelemetry = (conversationId) => {
    if (!conversationId) return;

    axios.post('/api/client-ip',
      {
        conversationId,
        cdoName: cdoName || ''
      },
      {
        withCredentials: true,
        timeout: 10000
      }).catch(error => {
        console.warn('Unable to capture client IP telemetry', error);
      });
  }


  // TODO: Move DirectLine connection logic to separate file
  const getDirectlineToken = async () => {
    console.log("Requesting DirectLine secret")
    
    let requestHeaders = {
      "Content-Type": "application/json",
        "Accept": "application/json",
      "x-cdo-name": cdoName
    }; 
    if (env && env.toLowerCase() !== "production") {
        requestHeaders['x-upstream-env'] = "nonprod";
        
      }
      try {
          console.log('Gateway token before DirectLine axios call:', GatewayToken);
      const response = await axios({
        method: "get",
        url: directLineTokenUrl,
        timeout: 0,
        headers: requestHeaders,
      })
      return { token: response.data }

      } catch (error) {
          console.error('Error from Directline Endpoint is: ', error,  ' GatewayToken: ', GatewayToken);
        //datadogLogs.logger.error('DirectLine token request failed', {
        //    url: directLineTokenUrl,
        //    status: error?.response?.status,
        //    message: error?.message,
        //    AsyncHBID: directLine.conversationId,
        //    token: GatewayToken
        //});

        // Capture exact request headers passed for this request for better debugging of 401 issues
        // This is temporary once the issue is rectified remove below code from this file. 
        if (error?.response?.status === 401) {
          const rawHeaders = error?.config?.headers;
          const headerObject = rawHeaders?.toJSON ? rawHeaders.toJSON() : (rawHeaders || {});
          const sanitizedHeaders = { ...headerObject };
          console.error("DirectLine token request returned 401. Request headers:", sanitizedHeaders);
        }
      return { error: error };
    }
  }
  const reconnectDirectline = async () => {
    console.log("Reconnecting to DirectLine");
    const reconnect = async () => {
      try {
        const response = await axios({
          method: "get",
          url: `${reconnectUrl}?conversationId=${encodeURIComponent(directLine.conversationId)}`,
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
        })
        directLine.reconnect({
          token: response.data.data.token,
          streamUrl: response.data.data.streamUrl
        });
        console.log('New Direcline Object: ', directLine);
      } catch (error) {
        console.error(error);
        return { error: error };
      }
    }
    return reconnect();
  }
  const listenForActivity = () => {
    directlineListener = directLine.activity$
      .filter((activity) => activity.type === 'message' && activity.from.id === filter)
      .subscribe((botMessage) => {
        // Bot activity id is `{conversationId}|{sequence}`; capture a reliable HBID early
        if (botMessage?.id?.includes('|'))
          conversationHBID = botMessage.id.split('|')[0];
        try {
          let message = JSON.parse(botMessage.text);
            if (lastSentAt) {
            message._sentAt = lastSentAt;
            }

          // Handle 422 symptom error
          if (message && message?.symptomErrorType !== undefined) {
            setSymptomError({ errorType: message?.symptomErrorType, message: message?.message });
            return;
          }
          
          if (message?.type === 'echo')
            return sendMessage('message', message.text);
          if (message?.type === 'summary' || message?.type === 'summaryopen')
            setSummaryPrintData(message);

          // Reset any symptom error when a normal bot message arrives
          setSymptomError(null);

          message.id = parseInt(botMessage.id.split('|')[1]);

          if (message?.data?.length && message.data[0].current_step){
            var current_step = message.data[0].current_step;
             if(current_step === "interview"){
              current_step = 'survey';
            }
            updateProgress(current_step);
          }
          setMessages(
            messages => {
              if ((['calender', 'calendar'].includes(message.type)) && (messages.length) && (['calender', 'calendar'].includes(JSON.parse(messages[messages.length - 1]).type)))
                messages.pop();
              return [...messages, JSON.stringify(message)].sort((a, b) => JSON.parse(a).id - JSON.parse(b).id)
            }
          );
          console.log(message);
        }
        catch (e) {
          console.log("UNRECOGNIZED MESSAGE:")
          console.log(botMessage);
          console.log("MESSAGE WAS TRANSLATED TO:")
          console.log(JSON.parse(makeDLMessage(botMessage)))
          setMessages(messages => [...messages, makeDLMessage(botMessage)].sort((a, b) => JSON.parse(a).id - JSON.parse(b).id));
        }
      });
  }


  const connectDirectLine = (launchCode) => {
    directlineStatus = directLine.connectionStatus$
      .subscribe(connectionStatus => {
        switch (connectionStatus) {
          case ConnectionStatus.Uninitialized:    // the status when the DirectLine object is first created/constructed
            console.log('DirectLine Status: Uninitialized');
            break;
          case ConnectionStatus.Connecting:       // currently trying to connect to the conversation
            console.log('DirectLine Status: Connecting');
            break;
          case ConnectionStatus.Online:           // successfully connected to the converstaion. Connection is healthy so far as we know.
            addHBIDtoDocument();
            addHBIDtoDataDog();
            logClientIpTelemetry(directLine?.conversationId); // <-- add
            listenForActivity();
            lastSentAt = performance.now();
            console.log('DirectLine Status: Online');
            break;
          case ConnectionStatus.ExpiredToken:     // last operation errored out with an expired token. Your app should supply a new one.
            console.log('DirectLine Status: Token Expired');
            reconnectDirectline();
            break;
          case ConnectionStatus.FailedToConnect:  // the initial attempt to connect to the conversation failed. No recovery possible.          
            setMessages([JSON.stringify(connectErrCard)])
            console.log('DirectLine Status: Failed to Connect');
            break;
          case ConnectionStatus.Ended:            // the bot ended the conversation
            console.log('DirectLine Status: Ended')
            break;
          default:
            break;
        }
      });
    (trigger && trigger.trim())
      ? directLine
          .postActivity({
            type: 'invoke',
            name: 'InitConversation',
            from: { id: 'myUserId', name: 'myUserName', },
            value: {
              triggeredScenario: {
                trigger: trigger,
                args: {
                  launchCode: launchCode,
                  profileid: profileId,
                  locale: Locale,
                  CDOName: cdoName,
                },
              },
            },
          })
          .subscribe(
            (id) => console.log(id),
            (error) => { console.log("ERROR: " + error) }
          )

      : directLine
        .postActivity({
          type: 'conversationUpdate',
          name: 'InitConversation',
          from: { id: 'myUserId', name: "myUserName" },
          membersAdded: [{ id: profileId, name: "SympleNoteMember" }],
          "value": [{
            triggeredScenario: {
              trigger: "trigger",
              args: {
                asyncProfileId: profileId,
                Launchcode: launchCode,
                CDOName: cdoName,
                AppId: appId,
                SmartonFHIR: 'test string',
                IFAToken: InfermedicaToken, 
                deviceType: deviceTypeVal,
                locale: Locale,
              }
            }
          }]
        })
        .subscribe(
          (id) => console.log(id),
          (error) => { console.log("ERROR: " + error) }
        );
    // Refresh token periodically
    setInterval(reconnectDirectline, 600000);
  }

  const startDirectLine = async () => {    
    if (!launchCode && !profileId) return;


if(launchCode || profileId){
    let existingLaunchCode = (sessionStorage.getItem('launchCode') || '').trim();
    if(existingLaunchCode!==launchCode){
      if(existingLaunchCode)
          sessionStorage.removeItem('launchCode');
      if(launchCode)
          sessionStorage.setItem('launchCode', launchCode);
   const directlineToken = (await getDirectlineToken()).token;
      console.log("Directline Token: ", directlineToken);
    if (!directlineToken) return;
      directLine = new DirectLine({
      secret: directlineToken,
      webSocket: !isIPhoneSafari,
      pollingInterval: 1000,
      timeout: 60000,
    });
    connectDirectLine(launchCode);
    }
    else if(['open', 'optumincubator'].includes(cdoName?.toLowerCase()) && profileId){
    const directlineToken = (await getDirectlineToken()).token;
      console.log("Directline Token: ", directlineToken);
    if (!directlineToken) return;
      directLine = new DirectLine({
      secret: directlineToken,
      webSocket: !isIPhoneSafari,
      pollingInterval: 1000,
      timeout: 60000,
      conversationStartProperties: { locale: 'en-US' }
    });
    connectDirectLine(launchCode);
    }
    else{      
        setIsStarting(false);
        setIsLaunchCodeExists(true);        
        return;
    }    
  }
    console.log("DirectLine Object:", directLine)
    console.log("CDO Name: ", cdoName);
    console.log("APP_ID: ", appId);
    console.log("LAUNCH CODE: ", launchCode, "\nPROFILE ID: ", profileId);
  };
  useEffect(() => {
    console.log('Infermedica token: ', InfermedicaToken)
    startDirectLine();
  }, []);

  useEffect(() => {
    const INITIAL_GAP = 0;
    const pageHeight = document.getElementById('page-body').offsetHeight;
    if (document.getElementById('lastMessage')) {
      document.getElementById('lastMessage').scrollIntoView({
        alignToTop: true, behavior: "smooth"
      });
    }    
    (document.getElementById('chat-panel').offsetHeight > (pageHeight - (INITIAL_GAP + 1)))
      ? document.getElementById('chat-background').style.minHeight = 'auto'
      : document.getElementById('chat-background').style.minHeight = (pageHeight - (INITIAL_GAP + 1)) + 'px';
     // document.getElementById('loadingbar').style.minHeight = 'auto'
  });

  const makeDLMessage = (message) => {
    // This function converts messages coming from infermetica into a standardized Optum healthbot messages
    try {
      var dlMessage = {
        type: message.type || 'error',
        text: message.text,
        id: parseInt(message.id ? message.id.split('|')[1] : Math.floor(Math.random() * 100000) + 100000)
      }
      if (!message.text) {
        message.type = 'error'
        message.text = 'This message is in an unrecognized format.'
        return JSON.stringify(dlMessage);
      }
      return JSON.stringify(dlMessage);
    }
    catch (e) {
      dlMessage = {
        type: 'error',
        text: 'This message is in an unrecognized format.',
        id: parseInt(Math.floor(Math.random() * 100000) + 100000)
      }
      return JSON.stringify(dlMessage);
    }
  };
  const rewindTo = (value, unsubmit) => {
    console.log("REWINDING TO: " + value);
    while (messages.length) {
      let lastMessage = JSON.parse(messages[messages.length - 1]);
      if (lastMessage.data && lastMessage.data.length && lastMessage.data[0] && (lastMessage.data[0].question_id === value)) break;
      messages.pop();
      // rewind to a string indentifying the card type
      if (lastMessage.type === value) {
        messages.push(JSON.stringify(lastMessage));
        break;
      }
      // rewind has an array indentifying the card types
      if (Array.isArray(value) && value.includes(lastMessage.type)) {
        messages.push(JSON.stringify(lastMessage));
        break;
      }
    }
    setMessages([...messages]);
  }
  const refreshProgress = (rewound) => {
    const localMessages = [...messages];
    const filtered = localMessages.filter((message) => {
      message = JSON.parse(message);
      return (message.data && message.data[0] && message.data[0].current_step);
    })
    // Update the progress with the last progress marker in filtered messages
    if ((typeof updateProgress === "function")) {
      filtered.length
        ? updateProgress(JSON.parse(filtered[filtered.length - 1]).data[0].current_step)
        : updateProgress('start')
    }
  }
  const isLastMessage = (index,message) => {
    if (index > messages.length - 1) return false;
  
    const cardBefore = (messages.length > 1)
      ? JSON.parse(messages[messages.length - 2])
      : { type: '' }
    // Never scroll to NPS after confirmation
    if ((index === messages.length - 1) && cardBefore.type === 'confirmation' && message.type === 'nps')
      return false;
    //  Is 2nd last and Confirmation?
    if (index === messages.length - 2 && (message.type === "confirmation"))
      return true;
    //  Is 2nd last and emergency?
    if (index === messages.length - 2 && (message.type === 'nine11' || message.type === 'emergency'))
      return true;
    if(message.type === 'message')
      return false;
    // Is last message?
    return (index === messages.length - 1)
  }

  const {timings} = useTiming();
  const sendMessage = (type, text, value, cardName) => {
    let cardLoadTime = null;
    if (Array.isArray(timings)) {
      cardLoadTime = timings.find(t => t.card === cardName);
    }
    lastSentAt = performance.now();

    if (type === 'rewind') {
      rewindTo(value, true);
      refreshProgress(true);
      return;
    }
    if (type === 'fastforward') {
      document.getElementById('endOfMessages').scrollIntoView({ behavior: "smooth", block: 'start' });
      refreshProgress();
      return;
    }
    if (type === 'restart') {
      setRestart(true);
      return;
    }
    if (type === 'nps-answered') {
      setIsNPSAnwered(value);
      return;
    }
    console.log("SENDING TYPE: " + type + "   TEXT: " + text + "   VALUE: " + value);
    var sentAt = performance.now();

    directLine
      .postActivity({
      type: type,
      from: { id: 'myUserId', name: "myUserName" },
      text: text,
      value: {
        value: value, // existing parameters
        cardLoadTime: cardLoadTime // add your new parameter here
      }
    })
    .subscribe(
      id => {
        if (id.toLowerCase() === 'retry') {
        logEventHub('Directline response timed out.', 'FE - Directline', directLine?.conversationId || conversationHBID, 'error')
        console.log(`RESPONSE TIMED OUT!\nWaited ${(Date.now() - sentAt) / 1000} seconds`)
        }
        else {
        console.log('Activity posted - ID: ', id);
        // Activity id is formatted as `{conversationId}|{sequence}`; use it as the HBID source
        const asyncHBID = directLine?.conversationId || conversationHBID || (id.includes('|') ? id.split('|')[0] : id);
         logEventHub(`Directline id: ${id}`, 'FE - Directline', asyncHBID)
        }
      },
      error => console.log('Error posting activity', error)
      );
  };
    //Derive starting/loading state from messages outside of render to prevent infinite re-renders
  useEffect(() => {
    // Keep loader until we have at least one message; mimic original intent
    if (!messages.length) {
      if (!isStarting) setIsStarting(true);
      return;
    }
    
      const lastMessage = messages[messages.length - 1];
      let containsFalseFlag = false;
      try {
        const parsed = JSON.parse(lastMessage);      
        if(parsed.type && parsed.type === "message" && parsed.text && parsed.text.length && parsed.text.toLowerCase().includes('loading your profile...'))
          containsFalseFlag=true;
      } catch (e) {
        containsFalseFlag = false;
      }
   
    if (isStarting !== containsFalseFlag) setIsStarting(containsFalseFlag);
  }, [messages]);
  const renderMessage = (message) => { 
    switch (message.type.toLowerCase()) {
      case 'conglomo-selfcare':
        return <Cards.ConglomoSelfCare message={message} sendMessage={sendMessage}/>
      case 'welcome':
      case 'welcome-optumincubator':
        return <Cards.Welcome
          message={message}
          sendMessage={sendMessage}
          setToastMessage={setToastMessage}
          disabled={isTriageOver || isConversationOver}
          showWelcomeIllustration={showWelcomeIllustration}          
        />
        case 'welcomenew':          
          return <Cards.WelcomeNew
            message={message}
            sendMessage={sendMessage}
            setToastMessage={setToastMessage}
            disabled={isTriageOver || isConversationOver}
            showWelcomeIllustration={showWelcomeIllustration}            
          />          
      case 'disclaimer':
        return <Cards.Disclaimer message={message} sendMessage={sendMessage} disabled={isTriageOver || isConversationOver} />
      case 'disclaimernew':
        return <Cards.DisclaimerNew message={message} sendMessage={sendMessage} disabled={isTriageOver || isConversationOver} />
      case 'age':
        return <Cards.Age message={message} sendMessage={sendMessage} disabled={isTriageOver || isConversationOver} />
      case 'gender':
        return <Cards.SingleSelect
          message={message}
          sendMessage={sendMessage}
          setToastMessage={setToastMessage}
          disabled={!isAfterSummaryorTreatmentPlan && (isTriageOver || isConversationOver)}
          allowEdits={!isAfterSummaryorTreatmentPlan}
        />
      case 'symptomscard':
        return <Cards.SymptomSearch message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} disabled={isTriageOver || isConversationOver} HoverColor={HoverColor} symptomError={symptomError} setSymptomError={setSymptomError}/>

      case 'evisitfasttrack':
        return <Cards.EvisitCard message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} disabled={isTriageOver || isConversationOver} isSpanish={isSpanish} />

      case 'symptomsdurationcard':
        return <Cards.SymptomDuration message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} disabled={isTriageOver || isConversationOver} HoverColor={HoverColor} />
      
      case 'symptomsquestioncard':
        return <Cards.SymptomQuestion message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} disabled={isTriageOver || isConversationOver} HoverColor={HoverColor} />
      case 'confirmation':
        if(cdoName?.toLowerCase() === "open")
        {
        return <></>;        
        }
        return <Cards.Confirm message={message} sendMessage={sendMessage} supressState={setSupressScreen} supressNPS={isNPSAnswered} setToastMessage={setToastMessage} setIsTriageOver={setIsTriageOver}/>        
      case 'confirmvirtual':
        return (!supressScreen && <Cards.ConfirmVirtual
          message={message}
          sendMessage={sendMessage}
          disabled={isConversationOver}
        />)
      case 'calender':
      case 'calendar':
        return (!supressScreen && <Cards.AppointmentPicker
          message={message}
          sendMessage={sendMessage}
          disabled={isConversationOver}
        />)
      case 'multicalendar':
        return (!supressScreen && <Cards.MultiAppointmentPicker
          message={message}
          sendMessage={sendMessage}
          disabled={isConversationOver}
        />)          
      case 'yesno':
      case 'prompt':
        return <Cards.SingleSelect
          message={message}
          sendMessage={sendMessage}
          setToastMessage={setToastMessage}
          disabled={!isAfterSummaryorTreatmentPlan && (isTriageOver || isConversationOver)}
          allowEdits={!isAfterSummaryorTreatmentPlan}
        />
      case 'singleselect':
        return <Cards.SingleNext
          message={message}
          sendMessage={sendMessage}
          disabled={!isAfterSummaryorTreatmentPlan && (isTriageOver || isConversationOver)}
        />
      case 'multichoice':
        return <Cards.MultiSelect
          message={message}
          sendMessage={sendMessage}
          disabled={isTriageOver || isConversationOver}
        />
      case 'groupmultiple':
        return <Cards.GroupSelect
          message={message}
          sendMessage={sendMessage}
          setToastMessage={setToastMessage}
          disabled={isTriageOver || isConversationOver}
        />
      case 'nine11':
        if (!isTriageOver) setIsTriageOver(true);
        isAfterSummaryorTreatmentPlan = true;
        return <Cards.Nine11 message={message} />
      case 'emergency':
        if (!isTriageOver) setIsTriageOver(true);
        isAfterSummaryorTreatmentPlan = true;
        return <Cards.Emergency message={message} />
      case 'text':
      case 'message': 
      /*for hiding the profile logs - commenting for now*/ 
       if (message.text) {
          const msgLowerCase = message.text.toLowerCase();
          if (msgLowerCase.includes('data load complete') || msgLowerCase.includes('loading your profile'))
          return null;    
        else if (msgLowerCase.includes('please wait or try again'))              
          return <Cards.Alert message={timeoutCard} sendMessage={sendMessage} allowRestart={allowRestart} isSpanish={isSpanish} />
        else if (msgLowerCase.startsWith('oops'))
          return <Cards.Alert message={message} sendMessage={sendMessage} allowRestart={allowRestart} isSpanish={isSpanish} />
        else if (msgLowerCase.includes('conversation has timed out')) {
          if (!isConversationOver)
            setIsConversationOver(true);
          return <Cards.Alert message={timeoutCard} sendMessage={sendMessage} allowRestart={allowRestart} isSpanish={isSpanish} />
        }
      }
        return <Cards.Text message={message} />;
      case 'summaryplaceholder':
        return (!suppressSummary && <Cards.SummarySkeleton message={message} />)
      case 'summary':
        if (!isTriageOver) setIsTriageOver(true);
        isAfterSummaryorTreatmentPlan = true;
        return <Cards.Summary message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} disabled={isConversationOver} HoverColor={HoverColor} setSuppressSummary={setSuppressSummary} locale={Locale}/>
      case 'summaryopen':
        if (!isTriageOver) setIsTriageOver(true);
        isAfterSummaryorTreatmentPlan = true;
        return <Cards.OpenSummary message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} disabled={isConversationOver} HoverColor={HoverColor} setSuppressSummary={setSuppressSummary} setPrintData={setSummaryPrintData} />
      case 'evisittos':
        return (!supressScreen && <Cards.EVisitTosSummary message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} />)
      case 'treatmentplan':
        return <Cards.TreatmentPlan message={message} sendMessage={sendMessage} disabled={isConversationOver} HoverColor={HoverColor} setToastMessage={setToastMessage} />
      case 'nps':
        // For Open CDO, skip automatic NPS rendering since it's embedded in summary
        // const cdoNameForNps = message?.data?.[0]?.cdoName || cdoName;
        // const isOpenCdoNps = (cdoNameForNps || '').toLowerCase() === 'open';
         if(cdoName?.toLowerCase() === "open")
        {
        return <></>;        
        }        
         return <Cards.NPS message={message} sendMessage={sendMessage} />        
        
      case 'thankyou':
        return <Cards.TextMessage message={message} sendMessage={sendMessage} />
      case 'textcard':
        return <Cards.TextCard message={message} sendMessage={sendMessage} />
      case 'freetext':
        if (!isTriageOver) setIsTriageOver(true);
        return <Cards.FreeTextField message={message} sendMessage={sendMessage} disabled={isConversationOver} />
      case 'timeout':
      case 'connecterr':
      case 'oops':
        if (!isConversationOver) setIsConversationOver(true);
        return <Cards.Alert message={message} sendMessage={sendMessage} allowRestart={allowRestart} isSpanish={isSpanish} />
      case 'error':
        if (!isConversationOver) setIsConversationOver(true);
        return <Cards.Error message={message} isSpanish={isSpanish} />
      case 'testing':
      case 'soap_note_saved':
        return <></>;
      default:
        message.type = 'error';
        message.text = isSpanish ? 'Este mensaje no se puede mostrar.' : 'This message cannot be displayed.';
        return <Cards.Error message={message} isSpanish={isSpanish} />
    }
  };
  const [loaderTextIndex, setLoaderTextIndex] = useState(0);
  
  const loaderTexts = [
    "Preparing your experience...",
    "Getting things ready for you...",
    "Almost ready..."
  ];

  const loaderTexts_Spa = [
    "Preparando su experiencia...",
    "Preparando todo para usted...",
    "Casi listo..."
  ];

  const isSpanishLocale = (Locale || '').toLowerCase().startsWith('es');
  const isSpanish = (UseSpanishVariation && isSpanishLocale);
  const activeLoaderTexts = isSpanish ? loaderTexts_Spa : loaderTexts;

  // Check if current card is a welcome card
  const isWelcomeCardPresent = () => {
    if (!messages.length) return true; // Show loader when no messages
    try {
      const lastMessage = JSON.parse(messages[messages.length - 1]);
      return lastMessage.type === "welcome" || lastMessage.type === "welcomenew" || lastMessage.type === "welcome-optumincubator";
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    if (isStarting && isWelcomeCardPresent()) {
      const interval = setInterval(() => {
        setLoaderTextIndex((prevIndex) => (prevIndex + 1) % activeLoaderTexts.length);
      }, 3000); 
      return () => clearInterval(interval);
    }
  }, [activeLoaderTexts.length, isStarting, messages]);

  const shouldTopAlignChat =
    isLaunchCodeExists ||
    (isStarting && cdoName?.toLowerCase() === "open" && isWelcomeCardPresent());

  return (
    <div id='triage-bot'>
      <div className={`chat-panel-container ${shouldTopAlignChat ? 'no-justify' : ''}`} id='chat-panel-container'>
        <div id='chat-panel' className='chat-panel'>
          {
            <div
              id='chat-background' className='chat-background'
            >
              {
                cdoName?.toLowerCase() === "open" && (messages.length>0) &&
                (
                  <div className="pre-welcome-heading-container">
                    <div className="pre-welcome-heading">First, we need to ask you a few questions</div>
                  </div>
                )
              }
              {
                isStarting && (
                  <div className="loading">
                    <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                      </svg>
                    {isWelcomeCardPresent() && <p className="loading-text">{activeLoaderTexts[loaderTextIndex]}</p>}
                </div>)
              }

              {
                isLaunchCodeExists &&(
                  <Cards.Alert message={sessionTimeoutCard} sendMessage={sendMessage} allowRestart={allowRestart} isSpanish={isSpanish} />
                )
              }
              {
                messages.map((message, i) => {
                  message = JSON.parse(message);
                  var cardName = '';
                  if (message?.text === 'Analyzing your symptoms...') {
                    cardName = "AnalyseSymptoms";
                  }
                  if (cardName === '' && (message?.data?.[0]?.question_id === 'TreatmentPlan')) {
                    cardName = message.data[0].question_id;
                  }
                  if (cardName === '' && (message?.data?.[0]?.current_step === 'triage_complete_call911')) {
                    cardName = 'triageCall911';
                  }
                  if (cardName === '' && (message?.data?.[0]?.current_step === 'triage_complete_emergency')) {
                    cardName = 'triageEmergency';
                  }
                  if (cardName === '') {
                    cardName = (message?.data?.[0]?.question_id) || null;
                    if (cardName == null)
                      cardName = (message?.data?.[0]?.current_step) || null;
                  }
                  message.isLastMessage = isLastMessage(i,message);
                  return (
                    <div key={message.id} className='turn' id={cardName}>
                      {
                        message.isLastMessage &&
                        <div id='lastMessage'>&nbsp;</div>
                      }
                      {                    
                        renderMessage(message)
                      }
                    </div>
                  );
                })
              }
              <div id='endOfMessages'>&nbsp;</div>
            </div>
          }
        </div>
        {
          toastMessage && <ToastDialog message={toastMessage} fullscreen={toastMessage.fullscreen} onClose={toastMessage.onClose} close={() => setToastMessage(null)} />
        }
        {
          showDebug && <DebugDialog showDebug={showDebug} reconnectDirectline={reconnectDirectline} sendMessage={sendMessage} directLine={directLine} onClose={() => setShowDebug(false)} />
        }
      </div>
    </div>
  );
}

export default function TriageBot(props) {
    return (
        <TimingProvider>
            <TriageBotContainer {...props} />
        </TimingProvider>
    );
}
